import { render, staticRenderFns } from "./OrdenDeTrabajo.vue?vue&type=template&id=b48736e8&scoped=true"
import script from "./OrdenDeTrabajo.vue?vue&type=script&lang=js"
export * from "./OrdenDeTrabajo.vue?vue&type=script&lang=js"
import style0 from "./OrdenDeTrabajo.vue?vue&type=style&index=0&id=b48736e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b48736e8",
  null
  
)

export default component.exports